import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from '../../api/axiosInstance';
import useAuthStore from '../../store/useAuthStore';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { isLoggedIn, role, checkAuth } = useAuthStore();

  // ✅ On mount, check auth and role — redirect if already admin
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (isLoggedIn && role === 'admin') {
      navigate('/admin/dashboard');
    }
  }, [isLoggedIn, role, navigate]);

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post('/admin/login', { email, password }, { withCredentials: true });

      const { token } = response.data;
      Cookies.set('token', token, { expires: 1 });

      // ✅ call zustand method to decode token and populate store
      checkAuth();

      navigate('/admin/dashboard');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Admin login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white px-4">
      <form
        onSubmit={handleAdminLogin}
        className="bg-gray-800 p-6 rounded-xl shadow-xl max-w-md w-full text-center"
      >
        <h2 className="text-2xl font-bold text-blue-500 mb-4">Admin Panel Login</h2>

        {error && <div className="mb-4 text-red-400">{error}</div>}

        <input
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-3 px-3 py-2 rounded bg-gray-700 border border-gray-600 placeholder-gray-400"
          required
        />

        <input
          type="password"
          placeholder="Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full mb-4 px-3 py-2 rounded bg-gray-700 border border-gray-600 placeholder-gray-400"
          required
        />

        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-blue-600 hover:bg-blue-700 transition font-bold py-2 rounded"
        >
          {isLoading ? 'Logging in...' : 'Login as Admin'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
